import { httpInstance } from '@/services/httpInstance';

const getAlliesService = async () => {
  let res;
  const endpoint = '/referrals/v1/promos/2';
  await httpInstance.get(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default getAlliesService;
